import React, { useEffect, useState } from "react";
import * as api from "../../api";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { RouteComponentProps } from "react-router-dom";
import CustomerCardDetails from "../../models/Customer/CustomerCardDetail";
import CustomerAssetCard from "../CustomerAssetCard";
import { PremisesAddress } from "../../models/shared/Address/PremisesAddress";
import { useDispatch, useSelector } from "react-redux";
import { getCustomer, getCustomerData, getWorkOrder } from "../APIErrorComponent/APIConstantName";
import { storeAPIErrors } from "../../ducks/redux/actions/FinancialReferral";
import { addAPIError, removeAPIError } from "../../utils/translation/helper";


interface WorkOrderCustomerCardProps extends RouteComponentProps<any> {
    customerId: string;
    propertyId: string;
    workOrderId: string;
    assetType: string;
    uprn?: string;
}
const WorkOrderCustomerCardComponent: React.FC<WorkOrderCustomerCardProps> = (props) => {
    let errorData: any = [];
    const dispatch = useDispatch();
    let customerResponse: CustomerCardDetails[] = [];
    const [isLoading, setIsLoading] = useState(false);
    const [customerIdList, setIsCustomerIdList] = useState(customerResponse);
    const errors = useSelector((state: any) => state.financialReferralReducer?.APIerrors);


    useEffect(() => {
       
            const uprn = props.uprn || "";
            getCustomers(props.customerId, props.propertyId, props.workOrderId, props.assetType, uprn);
      
    }, [props.customerId, props.propertyId, props.assetType, props.uprn]);

    const getCustomers =async (customerId: string, propertyId: string, workOrderId: string, assetType: string, uprn: string) => {
        
            try {
                let propertyCustomerList;
                setIsLoading(true)
                if (!customerId || !propertyId) {
                    const workOrderData = await api.getWorkOrder(workOrderId);
                    errorData = removeAPIError(getWorkOrder, errors);
                    dispatch(storeAPIErrors(errorData));
                    if (workOrderData != null) {
                        if (workOrderData.identifiers && (workOrderData.identifiers.customerIdentifier || (workOrderData.identifiers.asset && workOrderData.identifiers.asset.assetIdentifier))) {
                            propertyCustomerList = await fillPropertyCustomerList(workOrderData.identifiers.customerIdentifier ?? '', workOrderData.identifiers.asset.assetIdentifier, assetType, uprn);
                        }
                    }
                }
                else {
                    propertyCustomerList = await fillPropertyCustomerList(customerId, propertyId, assetType, uprn);
                }
                if (propertyCustomerList !== undefined) {
                    setIsCustomerIdList(propertyCustomerList);
                }

            }
            catch (e) {
                errorData = addAPIError(getCustomerData, errors);
                dispatch(storeAPIErrors(errorData));
                console.error(e);
            }
            finally{
                setIsLoading(false);
            }

        

    }

    const fillPropertyCustomerList = async (customerId: string, propertyId: string, assetType: string, uprn: string) => {
        let propertycustomerList: CustomerCardDetails[] = [];
      
        if (uprn && uprn !== "") {
            const queryParams = {
                searchText: "",
                limit: 10,
                skip: 0,
                customerType: "",
                orderBy: "",
                tenancyType: "",
                uprn: uprn
            };
            let customerCallResponse: any;
            try{
            customerCallResponse = await api.getCustomerData(queryParams);
            errorData = removeAPIError(getCustomerData, errors);
            dispatch(storeAPIErrors(errorData));
            }
            catch(e) {
                errorData = addAPIError(getCustomerData, errors);
                dispatch(storeAPIErrors(errorData));
                console.error(e);
               
              }
            const data = customerCallResponse?.models;
            if (assetType === 'Property') {
                data.map(async (element: CustomerCardDetails) => {
                    const check = propertycustomerList.filter(x => x.id === element.id)
                    if (check.length < 1) {
                        propertycustomerList.push(element);
                       if(element.id!=="" && element.id!==undefined && element.id!==null){
                        try{
                            await api.getCustomer(element.id);
                        }
                        catch(e) {
                            console.error(e);
                            
                          }
                       }
                    }
                })
                
            }
        }

        if (propertycustomerList.length === 0 && customerId && customerId !== "") {
            const propertyCustomerData = await fillCustomerWhileNoResultThroughUprn(customerId);
            if (propertyCustomerData) {
                propertycustomerList.push(propertyCustomerData);
            }
        }
        return propertycustomerList;
    }

    const fillCustomerWhileNoResultThroughUprn = async (customerId:string) => {
        let customerResponse: any;
        try{
        customerResponse = await api.getCustomer(customerId);
        
                                    errorData = removeAPIError(getCustomer, errors);
                                    dispatch(storeAPIErrors(errorData));
                                   } catch (e) {
                                      console.error(e);
                                     errorData = addAPIError(getCustomer, errors);
                                     dispatch(storeAPIErrors(addAPIError(getCustomer, errorData)));
           
          }
        let customerCardDetail = new CustomerCardDetails();
        customerCardDetail.id = customerResponse["customer-identifier"];

        customerCardDetail.givenName = customerResponse.person.name.givenName || "-";
        customerCardDetail.surname = customerResponse.person.name.surname || "-"
        customerCardDetail.email = customerResponse?.addresses.digitalAddresses.find(
            (a:any) => a.digitalAddressType === "email"
        )?.address || "-"
        customerCardDetail.homePhone = customerResponse?.addresses.telecomsAddresses.find(
            (a:any) => a.telecomsAddressType === "homePhone"
        )?.number || "-";
        customerCardDetail.workPhone = customerResponse?.addresses.telecomsAddresses.find(
            (a:any) => a.telecomsAddressType === "workPhone"
        )?.number || "-";
        customerCardDetail.mobilePhone = customerResponse?.addresses.telecomsAddresses.find(
            (a:any) => a.telecomsAddressType === "mobilePhone"
        )?.number || "-";
        customerCardDetail.tenancyModels = customerResponse?.addresses?.postalAddresses[0] as PremisesAddress

        return customerCardDetail;
    }

    return (<>
        {!isLoading ? (
            <CustomerAssetCard customerAssetList={customerIdList} {...props} />) : null}
    </>
    )
}

export default WorkOrderCustomerCardComponent;